import $ from './el.JsModules.js';

class Footer {
  constructor() {
    if (Footer.instance) {
      // This is a singleton, do not allow more than once instance
      return Footer.instance;
    }
    Footer.instance = this;
    this.initialise();
  }

  initialise = () => {
    this.initialiseNewsletterSignup();
    this.initialiseLogoVideo();
  };

  static getInstance() {
    if (!Footer.instance) {
      Footer.instance = new Footer();
    }
    return Footer.instance;
  }

  initialiseLogoVideo() {
    const video = document.querySelector('.el-footer__circular-logo-video');

    const observer = new IntersectionObserver(
      (entries) => {
        if (getComputedStyle(video).display === 'none') {
          observer.disconnect(); // Stop observing, webm with alpha is not supported
          return;
        }

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      },
      {
        threshold: 0.1, // adjust this depending on how visible it needs to be
      },
    );

    observer.observe(video);
  }

  initialiseNewsletterSignup() {
    $('.newsletter-signup-button').click(() => {
      this.performSignup($('.newsletter-signup-input').val());
    });

    $('.newsletter-signup-input').keypress((e) => {
      if (e.key === 'Enter') {
        this.performSignup($('.newsletter-signup-input').val());
      }
    });
  }

  async performSignup(emailAddress) {
    if (!emailAddress || !emailAddress.trim()) {
      alert('Please enter an email address');
      return;
    }

    try {
      const result = await elabs.newsletterService.signupNewsletter(emailAddress.trim(), 'footer');
      if (result.success) {
        elabs.newsletterService.handleSuccess();
        elabs.Utils.showToast('Thanks for subscribing to our newsletter!');
      }
    } catch (error) {
      elabs.Utils.showToast('There was a problem with subscribing you to the newsletter. Please try again.');
    }
  }
}

elabs.onJavascriptReady(function () {
  elabs.Footer = Footer.getInstance();
});
